<div>
    <div class="top-banner">
        <span>Prompt details</span>
        <mat-icon class="material-symbols-outlined btn-close" aria-label="Close notification window" role="button"
            fontIcon="close" (click)="closeNotification($event)" />
    </div>

    <div class="meta">
        <div class="meta-item"><span>Name:</span> <span>{{name}}</span></div>
        <div class="meta-item"><span>Description:</span> <span>{{description || 'No Description'}}</span></div>
        <div class="meta-item">
            <span class="label">Keywords:</span>
            @if (keywords && keywords.length > 0) {
            <div class="chips-container">
                <mat-chip-set>
                    @for (keyword of keywords; track keyword) {
                    <mat-chip>{{ keyword }}</mat-chip>
                    }
                </mat-chip-set>
            </div>
            } @else {
            <span>No Keywords</span>
            }
        </div>
        @if (model) {
        <div class="meta-item"><span>Model:</span> <span>{{model}}</span></div>
        }
        @if (temperature !== undefined) {
        <div class="meta-item"><span>Temperature:</span> <span>{{temperature}}</span></div>
        }
        @if (topP !== undefined) {
        <div class="meta-item"><span>top P:</span> <span>{{topP}}</span></div>
        }
        @if (type) {
        <div class="meta-item"><span>Type:</span> <span>{{type}}</span></div>
        }
        @if (prompt) {
        <div class="meta-item"><span>Prompt:</span> <span>{{ prompt }}</span></div>
        }
        @if (agent) {
        <div class="meta-item"><span>Agent:</span> <span>{{agent}}</span></div>
        }
        @if (fileUploadLabel) {
        <div class="meta-item"><span>File Upload Label:</span> <span>{{fileUploadLabel}}</span></div>
        }
        @if (collectInfoLabel) {
        <div class="meta-item"><span>Collect Info:</span> <span>{{collectInfoLabel}}</span></div>
        }
        <div class="meta-item"><span>Universal:</span> <span>{{isUniversal ? 'Yes' : 'No'}}</span></div>
        <div class="meta-item"><span>Enabled:</span> <span>{{isEnabled ? 'Yes' : 'No'}}</span></div>
        <div class="meta-item">
            <span>Users:</span>
            <span>
                @if (users && users.length > 0) {
                @for (user of users; track user; let last = $last) {
                {{user.name}}@if (!last) {, }
                }
                } @else {
                No Users
                }
            </span>
        </div>
        <div class="meta-item">
            <span>Owners:</span>
            <span>
                @if (owners && owners.length > 0) {
                @for (owner of owners; track owner; let last = $last) {
                {{owner.name}}@if (!last) {, }
                }
                } @else {
                No Owners
                }
            </span>
        </div>
        <div class="meta-item">
            <span>Groups:</span>
            <span>
                @if (groups && groups.length > 0) {
                @for (group of groups; track group; let last = $last) {
                {{group}}@if (!last) {, }
                }
                } @else {
                No Groups
                }
            </span>
        </div>
    @if (instructions && instructions.length > 0) {
        <div class="meta-item">
            <span class="label">Instructions:</span>
            <mat-nav-list role="list" class="session-detail-list">
                @for (instruction of instructions; track instruction) {
                <mat-list-item role="listitem" class="list-wrapper">
                    <div class="item-content">
                        <span>{{ instruction }}</span>
                    </div>
                </mat-list-item>
                }
            </mat-nav-list>
        </div>
    }

    @if (sensitivityLabels && sensitivityLabels.length > 0) {
        <div class="meta-item">
            <mat-nav-list role="list" class="session-detail-list">
                <div class="meta-item"><span>Sensitivity Labels:</span></div>
                @for (sensitivityLabel of sensitivityLabels; track sensitivityLabel) {
                <mat-list-item role="listitem" class="list-wrapper">
                    <div class="item-content">
                        <span>{{ sensitivityLabel.label }}</span>
                    </div>
                </mat-list-item>
                }
            </mat-nav-list>
        </div>
    }
    </div>
</div>